<template>
    <v-layout>
        <v-flex xs12>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4>
                        <form @submit.prevent="login()" v-model="valid" ref="form" lazy-validation>
                            <v-card class="elevation-12">
                                <v-toolbar dark color="primary">
                                    <v-toolbar-title>Ingreso al sistema</v-toolbar-title>
                                </v-toolbar>
                                <v-card-text>
                                    <v-text-field label="Usuario" v-model="username" required></v-text-field>
                                    <v-text-field label="Contraseña" type="password" v-model="password" required></v-text-field>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn type="submit" :loading="loading" color="primary">Ingresar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </form>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-flex>
    </v-layout>
</template>
<script>
    import {mapActions} from "vuex";

    export default {
        name: 'login',
        data() {
            return {
                loading: false,
                valid: false,
                username: '',
                password: '',
            }
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            async login() {
                this.loading = true;
                try {
                    const {data} = await this.$http.post('login', {username: this.username, password: this.password})
                    if (data.error) {
                        this.msjShow({tipo: 'error', txt: 'Error al intentar loguearse',});
                        return false
                    }
                    this.$ls.set('token', data.access_token);
                    this.loading = false;
                    this.$router.push('/home')
                }
                catch (err) {
                    console.log(err);
                    this.loading = false;
                    this.msjShow({tipo: 'error', txt: 'Error al intentar loguearse',});
                }

            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/auth/login.vue